module.exports = __webpack_public_path__ + "media/dog-profile-avatars/single-adult-dog-6ec7099a.svg";